import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { PageLayout, PageHeader, PageSection } from '../components/page-layout';
import { NavigationLink } from '../components/DesignSystem';

const Home: React.FC = () => {
  const { getThemeClasses, getThemeStyles } = useTheme();
  const themeClasses = getThemeClasses();
  const themeStyles = getThemeStyles();

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 font-sans">
      <PageLayout maxWidth="1200px">
      {/* Hero Section with Search */}
      <PageHeader
        title="La tua risorsa per affittuari affidabili"
        description="Verifica la reputazione di un affittuario prima di affittare"
      />

        {/* How It Works Section */}
        <PageSection title="Come Funziona">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Step 1: Cerca */}
            <div style={{
              backgroundColor: themeStyles.cardBackground,
              padding: '20px',
              borderRadius: '8px',
              border: `1px solid ${themeStyles.border}`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: '#e3f2fd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '15px',
                fontSize: '24px'
              }}>
                🔍
              </div>
              <h3 style={{
                color: themeStyles.primary,
                marginBottom: '10px',
                fontSize: '18px',
                fontWeight: '600'
              }}>
                1. Cerca un affittuario
              </h3>
              <p style={{
                color: themeStyles.textSecondary,
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                Inserisci i dettagli di un potenziale affittuario per vedere le valutazioni esistenti.
              </p>
            </div>

            {/* Step 2: Valuta */}
            <div style={{
              backgroundColor: themeStyles.cardBackground,
              padding: '20px',
              borderRadius: '8px',
              border: `1px solid ${themeStyles.border}`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: '#e3f2fd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '15px',
                fontSize: '24px'
              }}>
                ⭐
              </div>
              <h3 style={{
                color: themeStyles.primary,
                marginBottom: '10px',
                fontSize: '18px',
                fontWeight: '600'
              }}>
                2. Valuta il profilo
              </h3>
              <p style={{
                color: themeStyles.textSecondary,
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                Esamina le valutazioni e i commenti di altri proprietari per prendere una decisione informata.
              </p>
            </div>

            {/* Step 3: Contribuisci */}
            <div style={{
              backgroundColor: themeStyles.cardBackground,
              padding: '20px',
              borderRadius: '8px',
              border: `1px solid ${themeStyles.border}`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: '#e3f2fd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '15px',
                fontSize: '24px'
              }}>
                ➕
              </div>
              <h3 style={{
                color: themeStyles.primary,
                marginBottom: '10px',
                fontSize: '18px',
                fontWeight: '600'
              }}>
                3. Contribuisci
              </h3>
              <p style={{
                color: themeStyles.textSecondary,
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                Aggiungi la tua valutazione per aiutare la comunità di proprietari e gestori immobiliari.
              </p>
            </div>
          </div>
        </PageSection>

        {/* Recent Reviews Section */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{
            color: themeStyles.primary,
            fontSize: '2.5rem',
            fontWeight: 'bold',
            marginBottom: '20px'
          }}>
            Esempi di valutazioni
          </h2>
          <div className="reviews-container">
            <div className="reviews-inner">
              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 w-3/5 md:w-1/5 mx-auto md:mx-0">
                <div className="flex items-center mb-4">
                  <span className="text-3xl">⭐⭐⭐⭐⭐</span>
                  <span className="ml-2 text-xl font-semibold text-gray-700">5.0</span>
                </div>
                <p className="text-gray-700 italic mb-4">"Affittuario eccezionale, ha sempre pagato in tempo e ha mantenuto la proprietà in perfette condizioni."</p>
                <div className="text-sm text-gray-600">
                  <span className="font-medium">Valutato da:</span> Landlord123
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 w-3/5 md:w-1/5 mx-auto md:mx-0">
                <div className="flex items-center mb-4">
                  <span className="text-3xl">⭐⭐⭐</span>
                  <span className="ml-2 text-xl font-semibold text-gray-700">3</span>
                </div>
                <p className="text-gray-700 italic mb-4">"Problemi con i pagamenti ritardati e ha causato alcuni danni minori all'appartamento."</p>
                <div className="text-sm text-gray-600">
                  <span className="font-medium">Valutato da:</span> PropertyManager
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 w-3/5 md:w-1/5 mx-auto md:mx-0">
                <div className="flex items-center mb-4">
                  <span className="text-3xl">⭐⭐⭐</span>
                  <span className="ml-2 text-xl font-semibold text-gray-700">3.5</span>
                </div>
                <p className="text-gray-700 italic mb-4">"Affittuario nella media, qualche problema minore ma nulla di grave."</p>
                <div className="text-sm text-gray-600">
                  <span className="font-medium">Valutato da:</span> SaraH
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sign-up Section */}
        <PageSection title="Unisciti alla Comunità" icon="👥">
          <div className="text-center max-w-2xl">
            <p className="text-lg mb-8">
              Crea un account oggi per accedere al database completo e condividere le tue esperienze.
            </p>
            <NavigationLink to="/register">
              Registrati Ora
            </NavigationLink>
          </div>
        </PageSection>
      </PageLayout>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-20 px-4">
        <div className="py-20 container mx-auto text-center md:flex md:justify-between md:items-center">
          <div className="mb-4 md:mb-0">
            <p>© 2025 Grented. Tutti i diritti riservati.</p>
          </div>
          <div className="py-20 flex justify-center space-x-6">
            <Link to="/privacy-policy" className="px-4 hover:text-white">Informativa sulla privacy</Link>
            <Link to="/terms-of-service" className="hover:text-white">Termini di servizio</Link>
            <Link to="/faq" className="px-4 hover:text-white">FAQ</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;